import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { catchError, debounceTime, distinctUntilChanged, first, map, of, switchMap } from "rxjs";
import { GasMeterApprovalsService } from "src/app/services/gas-meter-approvals.service";

export function MeterQrCodeValidator(service: GasMeterApprovalsService, meterId: number | null): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) return Promise.resolve(null);
    return control.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(value => service.validateQrCode(value)),
      map(res => {
        const id = res.data?.id;
        return (id && meterId !== Number(id)) ? { qrCodeExist: true } : null;
      }),
      catchError(() => of(null)),
      first()
    );
  }
}